import React from "react";

import { useNavigateToLink } from "../../../components/react/link";
import { useQueryMainMenuGroups } from "../../../queries/mainmenu";
import { KUBERNETES_OVERVIEW_PATH } from "../../Routes";

import { GroupViewsIndexBreadcrumb } from "./GroupViewsIndexBreadcrumb";
import { ViewsIndexBreadcrumb } from "./ViewsIndexBreadcrumb";

export const KubernetesOverviewBreadcrumb: React.FC = () => {
	const { data: k8sGroup } = useQueryMainMenuGroups({
		select: (groups) => groups.find((group) => group.isKubernetes),
	});
	const k8sOverviewLink = useNavigateToLink(KUBERNETES_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (k8sGroup == null) {
		return <ViewsIndexBreadcrumb />;
	}

	return <GroupViewsIndexBreadcrumb group={k8sGroup} to={k8sOverviewLink} />;
};
